import { render, staticRenderFns } from "./AlgorithmClassView.vue?vue&type=template&id=66cdbace&"
import script from "./AlgorithmClassView.vue?vue&type=script&lang=js&"
export * from "./AlgorithmClassView.vue?vue&type=script&lang=js&"
import style0 from "./AlgorithmClassView.vue?vue&type=style&index=0&id=66cdbace&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports